// removed by extract-text-webpack-plugin
module.exports = {"header":"c2eeQzi3t0-uX7qqDJUqU","cover":"_2gS2yE8j53ixoVQLpUHeMl","invalidName":"_11dgfz7fxFGBCv9fr0EJUp","caption":"VVBZ3wFNztE_PviA-Zdep"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Header/Header.css
// module id = 189
// module chunks = 0